import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicy.module.css';

function PrivacyPolicy({ productName, lastUpdated, sections }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.privacyPage}>
      <div className={styles.header}>
        <Link to="/" className={styles.backLink}>&larr; Back to Home</Link>
        <h1 className={styles.title}>{productName} Privacy Policy</h1>
        <p className={styles.subtitle}>Castle Point Innovations &mdash; Cuitt LLC</p>
        <p className={styles.updated}>Last Updated: {lastUpdated}</p>
      </div>
      <div className={styles.content}>
        {sections.map((section, i) => (
          <div key={i} className={styles.section}>
            <h2 className={styles.sectionTitle}>{section.title}</h2>
            {section.content}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PrivacyPolicy;
